import * as PIXI from "pixi.js";
import Layers from "../../../../../src/layers/Layers";
import { Coord } from "../../../../../src/types/Interface";


export default class CalculationLine extends PIXI.Text {
  private Layers = Layers.getInstance();
  constructor(coord: Coord, color: number, initialVals: string[]) {
    super();
    Object.assign(this, coord);
    this.addText(color);
    this.text = `${initialVals[0]}° + ${initialVals[1]}° = 180°`
    this.addToLayer();
  }
  
  private addToLayer = () =>this.Layers.Info.addChild(this);
  private generateText = (degree1:number, degree2:number) => `${degree1}° + ${degree2}° ${ degree1 + degree2 == 180 ? "=" : "≠"} 180°`
  addText(color: number) {
    this.text = "x° + y° = 180°";
    this.style.fontWeight = "600";
    this.style.fill = color;
    this.style.fontSize = 40;
    this.anchor.set(1);
  }
  updateDegrees(degree1: number, degree2:number) {
    this.text = this.generateText(degree1, degree2);
  }
}